import React, { useEffect, useState } from "react";
import AutocompleteInput from "../../Components/AutocompleteInput";

function LabelAutocomplete({
  question,
  inputValue,
  placeholder,
  handleUpdateLabel,
  error,
  isLabelSelected,
  isSelected,
  disabled = false,
}) {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(inputValue);
  const [firstRun, setFirstRun] = useState(false); // don't trigger useEffect at startup
  const [disableAutoLabel, setDisbleAutoLabel] = useState(false); // don't choose a label

  useEffect(() => {
    // disable auto labeling if question is out of focus (e.g. create a new question)
    if (!isSelected) setDisbleAutoLabel(true);
  }, [isSelected]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const words = question
        .toLowerCase() // no capitals
        .replace(/[.,\/#!?$%\^&\*;:{}=\-_`~()]/g, "") // remove punctuation
        .split([" "]) // split space
        .filter((word) => word !== ""); // remove empty ones
      const wordFreqs = words.map((word) => ({
        word: word,
        f: window.WORDFREQ_NL()[word] ?? 10000, // in case word was not found: set higher frequency
      }));
      const sortedWordFreq = wordFreqs.sort((a, b) => a.f - b.f); // sort words from highest to lowest frequency
      const sortedWords = sortedWordFreq
        .map((word) => word.word)
        .filter((word, i, a) => a.indexOf(word) === i); // all words should be unqiue in the options list
      const importandLabel = sortedWords?.[0] ?? "";
      setOptions(sortedWords);
      if (firstRun && (!disableAutoLabel || value === "")) {
        setValue(importandLabel);
        handleUpdateLabel(importandLabel);
      }
    }, 500);
    setFirstRun(true);
    return () => {
      clearTimeout(timeOutId);
    };
  }, [question]);

  const handleChange = (_, value, reason) => {
    if (reason === "reset") return;
    setValue(value);
    handleUpdateLabel(value);
    setDisbleAutoLabel(true); // disable auto-complete when user manipulates label via input or selection
  };

  return (
    <AutocompleteInput
      options={options}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      error={error}
      textAlign="left"
      isSelected={isLabelSelected}
      disabled={disabled}
    />
  );
}

export default LabelAutocomplete;
